module.exports = __webpack_public_path__ + "static/img/ycls4.37877ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/ycls4.jpg
// module id = 87Xt
// module chunks = 0